import { useState } from 'react';
import { toast } from 'react-toastify';
import { loadRazorpay } from '../utils/loadRazorpay';
import { proceedToCheckout } from '../services/subscription';
import useAuth from './useAuth';

export const usePayment = () => {
	const { userOnboardingMe } = useAuth();
	const [loading, setLoading] = useState(false);

	const initiatePayment = async ({ billingDetails, plan, paymentType }) => {
		try {
			setLoading(true);

			const payload = {
				billing: {
					company_name: billingDetails.name,
					phone: billingDetails.phone,
					address_line1: billingDetails.address,
					city: billingDetails.city,
					state: billingDetails.state,
					pincode: billingDetails.pincode,
					country: billingDetails.country,
					gstin_required: billingDetails.gst,
					gstin: billingDetails.gstin || null,
				},

				plan: {
					razorpay_plan_id: plan.razorpay_plan_id,
					billing_period: plan.billingPeriod,
					is_recurring: paymentType === 'recurring',
				},
			};

			const response = await proceedToCheckout(payload);

			if (!response?.success) {
				toast.error(response?.message || 'Unable to proceed checkout');

				return;
			}

			const subscription = response?.data?.subscription;

			const razorpayLoaded = await loadRazorpay();

			if (!razorpayLoaded) {
				toast.error('Razorpay SDK failed to load');

				return;
			}

			const options = {
				key: subscription?.razorpay_key_id,
				subscription_id: subscription?.subscription_id,
				name: 'Pharmnex',
				description: `${subscription?.plan_name} - ${subscription?.billing_period}`,
				currency: subscription?.currency || 'INR',
				prefill: {
					name: subscription?.customer?.name,
					email: subscription?.customer?.email,
					contact: subscription?.customer?.phone,
				},

				theme: {
					color: '#3B58FF',
				},

				handler: async (paymentResponse) => {
					console.log('Razorpay Success:', paymentResponse);

					toast.success('Payment Successful');

					await userOnboardingMe();
				},

				modal: {
					ondismiss: () => {
						toast.error('Payment cancelled');
					},
				},
			};

			const razorpay = new window.Razorpay(options);

			razorpay.open();
		} catch (error) {
			console.error(error);

			toast.error(error?.response?.data?.message || 'Payment initialization failed');
		} finally {
			setLoading(false);
		}
	};

	return {
		initiatePayment,
		loading,
	};
};
